import { useState } from "react"

function useSliderPause() {
	const [isPaused, setIsPaused] = useState(false)

	const pause = () => {
		setIsPaused(true)
	}

	const resume = () => {
		setIsPaused(false)
	}

	return { isPaused, pause, resume }
}

export default useSliderPause;